import React from 'react';
import { Box, Center, Flex, Heading, Spinner, Text } from '@chakra-ui/react';
import { UserCard } from './components/UserCard';
import { useCollaboratorParams } from './hooks/useCollaboratorParams';
import { CollaboratorFilters } from './components/CollaboratorFilters';
import { PaginatorFooter } from '../../components/PaginatorFooter';

const Collaborators = () => {
  const { data, error, loading, queryParams, prevPage, nextPage, search } = useCollaboratorParams();

  return (
    <Flex direction="column" height="100%" flexGrow={1}>
      <Heading as="h2" fontSize="xl" marginBottom="12px" flexShrink={0}>
        Usuarios
      </Heading>

      <CollaboratorFilters onUpdate={search} queryParams={queryParams} />

      {loading && <Flex justifyContent="center" width="100%"><Spinner /></Flex>}
      {!!error && <Center color="neutral.800">Error cargando los datos</Center>}

        {!error && data && !loading &&
          <>
            <Box overflowY="auto" paddingX="xl" flexGrow="1">
              {data.content?.length
                ? data.content.map(user => <UserCard key={user.id} user={user} />)
                : <Text textAlign="center" color="neutral.600">No hay usuarios para esa sucursal</Text>}
            </Box>

            <Box marginTop="auto" position="sticky" bottom="0">
              <PaginatorFooter
                pageable={data.pageable}
                total_elements={data.total_elements}
                onPreviousPage={prevPage}
                onNextPage={nextPage} />
            </Box>
          </>
        }
    </Flex>
  );
};

export default Collaborators;
